import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { xScrollInjextionKey as m } from "./context.js";
import { defineComponent as f, inject as x } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const C = f({
  name: "VirtualListRow",
  props: {
    index: { type: Number, required: !0 },
    item: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const { startIndexRef: e, endIndexRef: t, columnsRef: n, getLeft: r, renderColRef: o, renderItemWithColsRef: l } = (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      x(m)
    );
    return {
      startIndex: e,
      endIndex: t,
      columns: n,
      renderCol: o,
      renderItemWithCols: l,
      getLeft: r
    };
  },
  render() {
    const { startIndex: e, endIndex: t, columns: n, renderCol: r, renderItemWithCols: o, getLeft: l, item: d } = this;
    if (o != null)
      return o({
        itemIndex: this.index,
        startColIndex: e,
        endColIndex: t,
        allColumns: n,
        item: d,
        getLeft: l
      });
    if (r != null) {
      const s = [];
      for (let i = e; i <= t; ++i) {
        const u = n[i];
        s.push(r({ column: u, left: l(i), item: d }));
      }
      return s;
    }
    return null;
  }
});
export {
  C as VirtualListRow
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/virtual-list/src/VirtualListRow.js
// module id = 1788
// module chunks = 67